<template>
  <div style="height: 100%;width: 100%">
    <el-container style="height: 100%;width: 100%;">
      <el-header class="padding" height="15%">
        <el-row :gutter="10">
          <el-col :span="3">
            <el-select v-model="thing" filterable clearable placeholder="物件番号">
              <el-option v-for="item in things" :key="item.id" :label="item.label" :value="item.value" ></el-option>
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select v-model="glassType" filterable clearable placeholder="玻璃类型">
              <el-option v-for="item in glassTypes" :key="item.id" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-button type="primary" style="width: 80px" :loading="searchLoading" @click="searchGlassInclusion">搜索</el-button>
          <el-button type="primary" style="width: 80px" plain :loading="resetLoading" @click="resetGlassInclusion">重置</el-button>
        </el-row>
      </el-header>
      <el-main class="padding" style="height: 85%">
        <el-button type="primary" plain style="width: 80px" @click="importClick">导入</el-button>
        <el-button type="primary" plain style="width: 80px" :loading="exportLoading" @click="exportGlassInclusion">导出</el-button>
        <el-table :data="tableData" border  style="width: 100%;height:78%;margin-top: 10px">
          <el-table-column prop="glass_type" label="玻璃类型 GLASS TYPE" width="150" />
          <el-table-column prop="glass_configuration" label="玻璃配置 CONFIGURATION" width="300" />
          <el-table-column prop="glass_width" label="W" width="100" />
          <el-table-column prop="glass_height" label="H" width="100" />
          <el-table-column style="background-color: #409EFF" prop="glass_1f" label="1F" width="100" >
            <template v-slot="scope">
              <div style="background-color: #409EFF;color: whitesmoke;width: 100%;">{{ scope.row.glass_1f }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="glass_2f" label="2F" width="100" >
            <template v-slot="scope">
              <div style="background-color: #409EFF;color: whitesmoke;width: 100%;">{{ scope.row.glass_2f }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="glass_3f" label="3F" width="100" >
            <template v-slot="scope">
              <div style="background-color: #1AB394;color: whitesmoke;width: 100%;">{{ scope.row.glass_3f }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="glass_4f" label="4F" width="100" >
            <template v-slot="scope">
              <div style="background-color: #409EFF;color: whitesmoke;width: 100%;">{{ scope.row.glass_4f }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="glass_5f" label="5F" width="100" >
            <template v-slot="scope">
              <div style="background-color: #409EFF;color: whitesmoke;width: 100%;">{{ scope.row.glass_5f }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="backup_usage" label="备片使用" width="100" />
          <el-table-column prop="plan_inclusion_sum" label="计划纳入総計 quantity plan to receive" width="300" />
          <el-table-column prop="inclusion_cnt" label="纳入数 quantity delivery to APSU" width="300" />
          <el-table-column prop="adjust_cnt" label="调整数（红字冲正数）" width="180" />
          <el-table-column prop="supplier_poor_cnt" label="不良数 quantity  of reject（caused by supplier)" width="300" />
          <el-table-column prop="apsu_poor_cnt" label="不良数 quantity of reject（caused by APSU）" width="300" />
          <el-table-column prop="poor_patch_cnt" label="不良已补片数量 replacment for reject" width="300" />
          <el-table-column prop="supplier_inventory_sum" label="供应商库存 quantity of supplier stock" width="300" />
          <el-table-column prop="available_cnt" label="可用数 quantity for APSU canbe used" width="300" />
          <el-table-column prop="summarize_sum" label="总结数量 summary quantity" width="150" />
        </el-table>
        <div class="pageStyle">
          <el-pagination
              style="margin-right: 13px"
              background layout="total, prev, pager, next"
              :total="total"
              :current-page="pageNum"
              @current-change="currentCheckChange"
              :page-size="pageSize">
          </el-pagination>
        </div>
      </el-main>
    </el-container>
  </div>

  <el-dialog  title="玻璃纳入导入" v-model="importBool" width="45%">
    <el-form label-width="100px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="模板下载">
            <el-link type="primary">玻璃纳入导入模板</el-link>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="导入说明">
            <el-input rows="5" type="textarea" disabled model-value="请按照模板整理后导入!导入失败请根据错误提示修改后即可再次导入。" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="选择文件">
            <el-upload
                ref="upload"
                class="upload-demo"
                :limit="1"
                :on-success="handleAvatarSuccess"
                :on-error="onError"
                :on-exceed="onExceed"
                :action="uploadUrl"
                :headers="uploadHeaders"
            >
              <template #trigger>
                <el-button type="primary" link>excel文件</el-button>
              </template>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item>
          <el-button type="primary" style="width: 100px;" :loading="importLoading" @click="importGlassInclusion()">导入</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "GlassInclusion",
  components:{},
  data(){
    return{
      thing:'',
      things:[],
      glassType:'',
      glassTypes:[],
      day : '',
      searchLoading:false,
      resetLoading:false,
      exportLoading:false,
      importLoading:false,
      importBool:false,
      uploadUrl:"",
      uploadHeaders:"",
      url:"/mfg/mfgGlassInclusion/getFile",
      countDayList:[],
      tableData:[],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      limit:1,
      fileId: '',
    }
  },methods:{

    onExceed(){
      this.$message.error('最多同时上传'+this.limit+"个文件。")
    },
    onError() {
      this.$message.error('网络异常，上传请求发送失败')
    },

    searchGlassInclusion() {
      this.searchLoading = true;
      let params = {wujian_id:this.thing, glass_type:this.glassType}
      this.$axios.post('mfg/mfgGlassInclusion/searchGlassInclusion', params).then(response => {
        this.searchLoading = false;
        let res = response.data
        if (res.code !== 0){
          return this.$message.error("获取数据失败");
        }

        this.tableData = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    resetGlassInclusion() {
      this.resetLoading = true;
      setTimeout(()=>{
        this.getWuJianInFo();
        this.getGlassInclusionAll()
        this.getMfgGlassInclusion();
        this.glassType = '';
        this.thing = '';
        this.resetLoading = false;
        return this.$message.success("重置成功");
      },500)

    },
    handleAvatarSuccess(uploadFile) {
      this.fileId = uploadFile.data.id;
    },
    importClick() {
      this.importBool = true;
    },
    importGlassInclusion() {
      if (!this.fileId) {
        return this.$message.error("fileId为空！");
      }
      this.importLoading = true;
      this.$axios.post('mfg/mfgGlassInclusion/importGlassInclusion', this.fileId).then(response => {
        this.importLoading = false;
        this.importBool = false;
        let res = response.data
        if (res.code != 0){
          return this.$message.error(`导入失败` + res.message);
        }

        this.getGlassInclusionAll();
        return this.$message.success("全部导入成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    exportGlassInclusion() {
      this.exportLoading = true;
      this.$axios.post('mfg/mfgGlassInclusion/exportGlassInclusion', this.tableData).then(response => {
        this.exportLoading = false;
        let res = response.data
        if (res.code !== 0){
          return this.$message.error("导出失败" + res.message);
        }

        console.log("res:==", res)
        const url = res.data.data.url;
        const originalName = res.data.data.originalName;
        if (url) {
          const link = document.createElement('a');
          link.href = url;
          link.download = originalName || '' // 下载文件的名字
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        }
        return this.$message.success("导出成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    currentCheckChange(page_num) {
      this.pageNum = page_num;
      this.getGlassInclusionAll();
    },
    getWuJianInFo() {
      this.$axios.post('mfg/mfgGlassInclusion/getWuJianInFo').then(response => {
        let res = response.data
        if (res.code !== 0){
          return this.$message.error("获取数据失败");
        }

        this.things = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    getGlassInclusionAll() {
      let params = {pageNum: this.pageNum, pageSize: this.pageSize}
      this.$axios.post('mfg/mfgGlassInclusion/getGlassInclusionAll',params).then(response => {
        let res = response.data
        if (res.code !== 0){
          return this.$message.error("获取【玻璃纳入】数据失败");
        }

        this.total = res.data.total;
        this.tableData = res.data.records;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    getMfgGlassInclusion()  {
      this.$axios.post('mfg/mfgGlassInclusion/getMfgGlassInclusion').then(response => {
        let res = response.data
        if (res.code !== 0){
          return this.$message.error("获取【玻璃纳入】数据失败");
        }

        this.glassTypes = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
  },created() {
    this.uploadUrl = process.env.VUE_APP_AXIOS_BASE_URL + this.url;
    this.uploadHeaders = {token: localStorage.getItem('token')}
    this.getWuJianInFo();
    this.getGlassInclusionAll();
    this.getMfgGlassInclusion();
  }
}
</script>

<style scoped>
.padding {
  padding: 5px;
}

.pageStyle{
  width: 100%;
  display: flex;
  justify-content:flex-end;
  margin: 20px 0
}

.el-table :deep(.cell) {
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding: 0 12px;
  text-align: center;
}

.upload-demo {
  width: 50%;
}

</style>